import { nextTick, onMounted, Ref, watch } from 'vue';
import { isNullish } from '@tinyurldev/tu-ui-vue';
import { breakpointsBootstrapV5, useBreakpoints, useEventListener } from '@vueuse/core';

export type ResizableChart = {
  resize: () => void;
};

export function useHandleResize(chartRef: Ref<ResizableChart | null>): void {
  const breakpoints = useBreakpoints(breakpointsBootstrapV5);
  const isMobileView = breakpoints.smallerOrEqual('xl');

  function handleResize(): void {
    if (isNullish(chartRef.value)) {
      return;
    }

    chartRef.value.resize();
  }

  useEventListener('resize', handleResize);

  onMounted(() => {
    nextTick(() => { handleResize(); });
  });

  watch(isMobileView, () => {
    nextTick(() => { handleResize(); });
  });
}
